(ns common.security.password
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.security.password-complexity :as password-complexity]
            [common.util :as cu]))

(defonce validation-rules
         [:length-8-rule])

(defn min-length [tenant]
  (or (:tenant/password-min-length tenant)
      8))

(defn constraints [tenant]
  (or (:tenant/password-complexity tenant)
      (->> password-complexity/complexity-options
           (map :key)
           (set))))

(defn tenant-constraints-text [tenant]
  (let [constraints (constraints tenant)
        min-length (min-length tenant)
        constraint-names (some->> constraints
                                  (map (fn [k]
                                         (->> password-complexity/complexity-options
                                              (filter (fn [o]
                                                        (= k (:key o))))
                                              (first)
                                              :plural-lower-case)))
                                  (seq))
        complexity-names (if (> (count constraint-names) 1)
                           (loc/tr :and [(string/join ", " (butlast constraint-names)) (last constraint-names)])
                           (first constraint-names))]
    (if (empty? constraints)
      (loc/tr :password-length [min-length])
      (loc/tr :password-length-and-complexity [min-length complexity-names]))))

(defn valid-password? [password tenant]
  (let [min-length (min-length tenant)
        constraints (constraints tenant)]
    (and password
         (>= (count password) min-length)
         (->> constraints
              (remove (fn [k]
                        (case k
                          :password-complexity/capital-case (re-find #"[A-Z]" password)
                          :password-complexity/lower-case (re-find #"[a-z]" password)
                          :password-complexity/number (re-find #"[0-9]" password)
                          :password-complexity/special-character (re-find #"\W|_" password)
                          nil)))
              (empty?)))))


(defn validate-error
  ([tenant pw]
   (let [min-len (min-length tenant)
         max-len 200
         constraints (constraints tenant)]
     (cond (empty? (cu/str-trim-lcase pw))
           (loc/tr :password-error-empty)
           (< (count pw) min-len)
           (loc/tr :password-error-too-short [min-len])
           (> (count pw) max-len)
           (loc/tr :too-long-password [200])
           :else
           (->> constraints
                (map (fn [c]
                       (case c
                         :password-complexity/capital-case (when-not (re-find #"[A-Z]" pw)
                                                             (loc/tr :password-violation/missing-capital-case))
                         :password-complexity/lower-case (when-not (re-find #"[a-z]" pw)
                                                           (loc/tr :password-violation/missing-lower-case))
                         :password-complexity/number (when-not (re-find #"[0-9]" pw)
                                                       (loc/tr :password-violation/missing-number))
                         :password-complexity/special-character (when-not (re-find #"\W|_" pw)
                                                                  (loc/tr :password-violation/missing-special-character)))))
                (remove nil?)
                (first)))))
  ([tenant pw1 pw2]
   (or (when (string/blank? pw1)
         (loc/tr :password-error-empty))
       (when (not= pw1 pw2)
         (loc/tr :password-error-not-matching))
       (validate-error tenant pw1))))
